// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "RoutingMetadataPromptVersionDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const RoutingMetadataPromptVersionDtoGenShape = z.strictObject({
  taggingSkillVersionId: z.string(),
  name: z.string(),
  versionLabel: z.string().optional(),
  publishedAt: z.string().optional(),
  systemPrompt: z.string(),
});
